import React, { useState } from "react";
import TagsInput from "react-tagsinput";
import { useField } from "formik";
import { useSelector } from "react-redux";
import { FormField, Popup } from "semantic-ui-react";

export function renderTagInput(props) {
  let { onChange, value, addTag, ...other } = props;
  return (
    <input
      type="text"
      onChange={onChange}
      maxLength={40}
      value={value}
      {...other}
    />
  );
}

export const TAG_INPUT_CHAR_LIMIT = (
  <div style={{ marginTop: 10 }}>
    <span className="semi-bold">Character limit:</span>
    <span> 40 including spaces</span>
  </div>
);

export default function MyProTagInput({
  formTags = [],
  maxTags = 6,
  placeholder = "Add a skill (press enter to add)",
  inputWidth = "55%",
  isShowCount = true,
  examples = [
    "English speaking",
    "Photoshop",
    "Cloud computing",
    "CSS frameworks",
    "Email marketing",
    "InDesign",
    "Adobe Illustrator",
    "UX/UI",
    "JavaScript",
  ],
  examplesHeading = "Highlight the skills you're looking for",
  examplesText = "Add up to 6 tags (certificates, licenses or technical/language skills).",
  isShowCharLimit = true,
  isDisabled = false,
  showError = false,
  ...props
}) {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(props);

  const { responsive } = useSelector((state) => state.app);

  const [tags, setTags] = useState(formTags);

  function handleChange(tags) {
    setTags(tags);
    helpers.setValue(tags);
  }

  return (
    <div className="pro-tag-input">
      <div style={{ width: responsive.isMobile ? "85%" : inputWidth }}>
        <FormField error={showError && !!meta.error} disabled={isDisabled}>
          <TagsInput
            value={tags}
            onChange={handleChange}
            inputProps={{
              className: "form-input-field react-tagsinput-input",
              placeholder: placeholder,
            }}
            maxTags={maxTags}
            onlyUnique={true}
            disabled={isDisabled}
            addOnBlur={true}
            renderInput={renderTagInput}
            removeKeys={[]}
          />
          {showError && meta.error && (
            <div className="error-message">{meta.error}</div>
          )}
        </FormField>
      </div>
      {isShowCount && (
        <div
          className={"pro-tag-input-comp"}
          style={{ marginTop: responsive.isMobile ? 10 : 0 }}
        >
          <span className="semi-bold">{tags.length}</span>
          <span>/{maxTags}</span>
        </div>
      )}
      {examples.length > 0 && (
        <div className={"pro-tag-input-comp"}>
          <Popup
            className="popup-container"
            content={
              <>
                <div className="popup-container-content body-blue-text">
                  {examplesHeading && <h3>{examplesHeading}</h3>}
                  {examplesText && <div>{examplesText}</div>}
                  {(examplesText || examplesHeading) && (
                    <div className="first-paragraph paragraph">Examples:</div>
                  )}
                  {examples.map((example, index) => (
                    <div key={index} className="skill-tag">
                      {example}
                    </div>
                  ))}
                </div>
                {isShowCharLimit && TAG_INPUT_CHAR_LIMIT}
              </>
            }
            // position="top right"
            on={["hover", "click"]}
            hoverable={true}
            trigger={
              <div className="popup-hover-text" style={{ paddingRight: 10 }}>
                Examples
              </div>
            }
          />
        </div>
      )}
    </div>
  );
}
